<template>
  <div>
    <Row class="pay-box">
      <Table
        :columns="payColumns" :loading="tableLoading"
        :data="payData"
      />
      <Row class="pay-detail">
        <div class="fr" style="font-size:14px;">总计:{{ common.formateNumber(allPay,"") }}元</div>
        <Row class="pay-detail-item">
          支付方式：
          <RadioGroup v-model="payForm.payType">
            <Radio label="online">
              <i class="icon-settlement-02 wx-icon"></i>
              <span>微信</span>
            </Radio>
          </RadioGroup>
        </Row>
      </Row>
    </Row>
    <Row class="has-read-tips">
      <Radio v-model="payForm.hasRead">
        我已阅读并同意<a href="javascript:void(0);" @click="openProvision">《购买条款》</a></Radio>
      <!-- <span>请阅读：<a href="javascript:void(0);" @click="openProvision">《购买条款》</a></span> -->
    </Row>
    <Row style="text-align:center;margin:10px 0px 14px;">
      <Button
        v-if="!isSumbit" type="primary"
        :disabled="isSumbit || !payForm.hasRead" @click="sumbitPay"
      >确认支付</Button>
      <Button
        v-if="isSumbit" type="primary"
        loading
      >支付申请中</Button>
      <Button style="margin-left: 8px" @click="$emit('closeModal',false)">取消</Button>
    </Row>

    <!-- 发起支付modal -->
    <Modal
      v-model="codeCtrl"
      :width="450"
      :mask-closable="false"
      :closable="false"
      :footer-hide="true"
    >
      <code-pay
        v-if="codeCtrl"
        :pay-obj="payObj"
        pay-tips="此案件包已为您预定，锁定期间其余团队不可购买，请在剩余时间内完成支付，超时未支付，此案件包将会退回交易大厅"
        @doneFunc="successFunc"
        @closeModal="codeCtrl=false;"
      />
    </Modal>
    <!-- 购买条款 -->
    <Modal
      v-model="provisionCtrl"
      title="购买条款"
      :width="800"
      :footer-hide="true"
      :closable="false"
      :mask-closable="false"
    >
      <pay-text @changeModal="changeModal" />
    </Modal>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
import payText from './../orderManage/payText.vue'
import surchargeFeeExpand from './surchargeFeeExpand.vue'
export default {
  components: {
    surchargeFeeExpand,
    payText
  },
  props: {
    // 购买的案件list
    payObjList: {
      type: Array
    },
    // 案件包的明细（需要用来判断起批量、剩余案件）
    defaultData: {
      type: Object | String
    }
  },
  data () {
    return {
      styles: styles,
      isSumbit: false,
      tableLoading: false,
      payForm: {
        payType: 'online',
        hasRead: true
      },
      payColumns: [
        {
          title: '案件编号',
          key: 'caseCode',
          width: 110
        },
        {
          title: '所属任务',
          key: 'missionName',
          render: (h, params) => {
            return h('span', {
              class: ['textover'],
              attrs: { title: params.row.missionName }
            }, params.row.missionName)
          }
        },
        {
          title: '案件区域',
          key: 'provinceName',
          render: (h, params) => {
            const str = `${params.row.provinceName || ''}${params.row.cityName || ''}${params.row.areaName || ''}`
            return h('span', {
              class: ['textover'],
              attrs: { title: str }
            }, str)
          }
        },
        {
          title: '对方当事人',
          key: 'caseExtend',
          render: (h, params) => {
            if (!params.row.caseExtend) {
              return h('span', '')
            }
            const domArr = []
            const idArr = params.row.caseExtend.litigantIds ? params.row.caseExtend.litigantIds.split(',') : []
            const categoryArr = params.row.caseExtend.litigantCategories ? params.row.caseExtend.litigantCategories.split(',') : []
            const nameArr = params.row.caseExtend.litigantNames ? params.row.caseExtend.litigantNames.split(',') : []
            nameArr.forEach((item, index) => {
              const iconDom = h('span', {
                class: 'descripe-icon',
                style: {
                  'marginRight': '5px'
                }
              }, categoryArr[index] && categoryArr[index] === 'M' ? '生' : '销')
              const spanDom = h('span', item)
              const pDom = h('p', {
                class: 'textover',
                attrs: { title: item },
                style: {
                  'marginBottom': index != nameArr.length - 1 ? '5px' : '0'
                }
              }, [iconDom, spanDom])
              domArr.push(pDom)
            })
            return h('div', {
              style: {
                'padding': nameArr.length > 1 ? '5px 0' : '0'
              }
            }, domArr)
          }
        },
        {
          title: '取证状态',
          key: 'certStateName',
          render: (h, params) => {
            let color = ''
            switch (params.row.certState) {
              case 'P': color = 'warning'; break
              case 'W': color = 'blue'; break
              case 'A': color = 'green'; break
            }
            return h('Tag', {
              class: ['textover'],
              attrs: { color: color }
            }, params.row.certStateName)
          }
        },
        {
          title: '出售价格',
          key: 'sellFee',
          render: (h, params) => {
            if (params.row.caseSaleBagItemExtend) {
              return h(surchargeFeeExpand, {
                props: {
                  row: params.row,
                  isBaseFee: true,
                  scale: params.row.scale || 0
                }
              })
            } else {
              return h('span', this.common.formateNumber(params.row.sellFee || 0))
            }
          }
        },
        {
          title: '定金',
          key: 'prepayFee',
          render: (h, params) => {
            return h('span', this.common.formateNumber(params.row.prepayFee || 0))
          }
        }
      ],
      provisionCtrl: false,
      payObj: {},
      codeCtrl: false,
      payData: []
    }
  },
  computed: {
    idList() {
      const arr = []
      this.payObjList.forEach((item, index) => {
        arr.push(item.id)
      })
      return arr
    },
    allPay() {
      let num = 0
      this.payData.forEach((item, index) => {
        num += item.prepayFee || 0
      })
      return num
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    this.getPayData()
  },
  mounted() {
  },
  updated() {},
  methods: {
    changeRadio() {
      this.payForm.hasRead = !this.payForm.hasRead
    },
    changeModal() {
      this.provisionCtrl = false
    },
    // 获取支付案件的信息
    getPayData() {
      const url = '/settlement/trade/sale/bag/item/prepay'
      // let ajaxData = {
      //     saleBagItemIds:""
      // }
      // this.idList.forEach((item,index)=>{
      //     ajaxData.saleBagItemIds += item;
      //     if(index!=this.idList.length-1){
      //         ajaxData.saleBagItemIds += ","
      //     }
      // })
      const ajaxData = this.idList
      this.tableLoading = true
      this.$post(url, ajaxData).then(res => {
        this.tableLoading = false
        if (res.code == 0) {
          this.payData = res.data
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    openProvision() {
      this.provisionCtrl = true
    },
    sumbitPay() {
      const url = '/settlement/order/lawyer'
      const ajaxData = {
        payMode: 'WePay',
        saleBagId: this.defaultData.id,
        saleBagItemIds: this.idList
      }

      // 公共包支付时需要进行一下判断
      if (this.defaultData.type == 'P') {
        // 如果待出售案件数量小于起批量，只能将剩下的案件全部购买
        if ((this.defaultData.forSaleNum < this.defaultData.batchNum) && (ajaxData.saleBagItemIds.length != this.defaultData.forSaleNum)) {
          this.$Message.error(`可购买案件数量小于起批量，应全部购买，请重新下单`)
          return
        }

        // 如果所购买的案件小于起批量，提示重新下单
        if ((this.defaultData.forSaleNum >= this.defaultData.batchNum) && (ajaxData.saleBagItemIds.length < this.defaultData.batchNum)) {
          this.$Message.error(`购买案件数量小于起批量，请重新下单`)
          return
        }
      }

      this.isSumbit = true
      this.$post(url, ajaxData).then(res => {
        this.isSumbit = false
        if (res.code == 0) {
          this.payObj = res.data
          this.codeCtrl = true
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    // 支付成功的回调
    successFunc() {
      setTimeout(() => {
        this.$emit('closeModal', true)
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./../orderManage/payPage.scss";
@import "../casePackage/packageDetail.scss";
</style>



// WEBPACK FOOTER //
// src/view/tradingCenter/casePackage/prePayPage.vue